import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';

import { ActionType } from './action-type';
import { actionTypeArray } from './action-type-array';

const stateContainer = {
    recording: false,
    actionLog: [],
};

function serve(): void {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const buffer = `[${stateContainer.actionLog.reduce(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        (p, c, ci) => `${p}${ci === 0 ? '' : ','}${c}`,
        '',
    )}]`;
    const blob = new Blob([buffer], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `recording_${Date.now()}.json`;
    link.click();
    URL.revokeObjectURL(link.href);
}

function processAction(
    api: MiddlewareAPI,
    next: Dispatch,
    action: AnyAction,
): any {
    let result: any;
    let didNext = false;
    try {
        if (
            !stateContainer.recording &&
            action.type === ActionType.RECORD_START
        ) {
            stateContainer.recording = true;
        }
        if (stateContainer.recording) {
            stateContainer.actionLog.push(JSON.stringify(action));
        }
        if (action.type === ActionType.RECORD_STOP) {
            stateContainer.recording = false;
        }
        if (!actionTypeArray.includes(action.type)) {
            result = next(action);
            didNext = true;
        }
        if (action.type === ActionType.RECORD_SERVE) {
            serve();
        }
        if (action.type === ActionType.RECORD_CLEAR) {
            stateContainer.actionLog = [];
        }
    } catch (err) {
        if (!didNext) {
            result = next(action);
        }
    }
    return result;
}

function actioner(
    api: MiddlewareAPI,
    next: Dispatch,
): (action: AnyAction) => any {
    return (action) => {
        return processAction(api, next, action);
    };
}

function dispatcher(
    api: MiddlewareAPI,
): (next: Dispatch) => (action: AnyAction) => any {
    return (next) => {
        return actioner(api, next);
    };
}

export function createDebugMiddleware(): Middleware {
    return (api) => {
        return dispatcher(api);
    };
}
